/*ReactJS*/
import React, { useState, useEffect } from 'react';

import { Box, IconButton } from '@material-ui/core';

/*Material UI Table*/
import MUIDataTable from 'mui-datatables';

import { Create as EditIcon, Delete as DeleteIcon } from '@material-ui/icons';

/*Styles*/
import tableTheme from '../../../components/Table/ImportTableStyle';
import { MuiThemeProvider } from '@material-ui/core/styles';
import useStyles from '../../../styles';
import moment from 'moment/moment.js';

import TransactionUploadEditModal from './TransactionUploadEditModal';

import { checkEntryType } from '../../../services/TransactionService';
import { downloadExcelData } from '../../../services/ExcelService';

export default function TransactionTable({
  entrytype,
  data,
  isEdit,
  editData,
  onEditOpen: handleOpen,
  onEditClose: handleClose,
  onRowDelete: handleDelete,
}) {
  const classes = useStyles();

  const [tableTitle, setTableTitle] = useState('All');
  const [fileName, setFileName] = useState('All');

  useEffect(() => {
    if (checkEntryType(entrytype) === 'trd') {
      setTableTitle('Trade');
      setFileName('trade-sample-sheet');
    } else if (checkEntryType(entrytype) === 'pm') {
      setTableTitle('Position Movement');
      setFileName('position-movement-sample-sheet');
    } else if (checkEntryType(entrytype) === 'cm') {
      setTableTitle('Cash Movement');
      setFileName('cash-movement-sample-sheet');
    } else if (checkEntryType(entrytype) === 'cpm') {
      setTableTitle('Cash and/or Position Movement');
      setFileName('cash-position-movement-sample-sheet');
    } else {
      setFileName('all-entry-type-sample-sheet');
      setTableTitle('All');
    }
  }, [entrytype]);

  const columns = [
    {
      name: '',
      options: {
        draggable: false,
        resizable: false,
        print: false,
        searchable: false,
        filter: false,
        sort: false,
        empty: true,
        viewColumns: false,
        customBodyRenderLite: (dataIndex) => {
          return (
            <div
              align={'left'}
              className={classes.grdRow}
              style={{ margin: 0, padding: 0 }}
            >
              <div className={classes.grdCellNone}>
                <IconButton
                  aria-label="delete"
                  onClick={() => {
                    handleDelete([{ dataIndex: dataIndex }]);
                  }}
                >
                  <DeleteIcon />
                </IconButton>
              </div>
              <div align={'left'} className={classes.grdCellNone}>
                <IconButton
                  aria-label="edit"
                  onClick={() => handleOpen(data[dataIndex])}
                >
                  <EditIcon />
                </IconButton>
              </div>
            </div>
          );
        },
      },
    },
    {
      name: 'correspondent',
      label: 'Correspondent',
    },
    {
      name: 'accountNo',
      label: 'Account No',
      options: {
        customBodyRenderLite: (dataIndex) => {
          const v = data[dataIndex].accountNo;

          return (
            <div className={v === '' ? classes.errBadge : null}>
              {v === '' ? 'Missing Value' : v}
            </div>
          );
        },
      },
    },
    {
      name: 'entryType',
      label: 'Entry Type',
      options: {
        customBodyRenderLite: (dataIndex) => {
          const v = data[dataIndex].entryType;

          return (
            <div className={v === '' ? classes.errBadge : null}>
              {v === '' ? 'Missing Value' : v}
            </div>
          );
        },
      },
    },
    {
      name: 'entrySubtype',
      label: 'Entry Subtype',
      options: {
        display:
          tableTitle === 'Cash Movement' ||
          tableTitle === 'Cash and/or Position Movement' ||
          tableTitle === 'All'
            ? true
            : false,
      },
    },
    {
      name: 'tradeDate',
      label: 'Trade Date',
      options: {
        display: tableTitle === 'Trade' || tableTitle === 'All' ? true : false,
        customBodyRenderLite: (dataIndex) => {
          const v = data[dataIndex].tradeDate
            ? moment(data[dataIndex].tradeDate).format('YYYY-MM-DD')
            : '';

          return (
            <div className={v === '' ? classes.errBadge : null}>
              {v === '' ? 'Missing Value' : v}
            </div>
          );
        },
      },
    },
    {
      name: 'tradeAt',
      label: 'Trade At',
      options: {
        display: tableTitle === 'Trade' || tableTitle === 'All' ? true : false,
      },
    },
    {
      name: 'symbol',
      label: 'Symbol',
      options: {
        display:
          tableTitle === 'Trade' ||
          tableTitle === 'Position Movement' ||
          tableTitle === 'Cash and/or Position Movement' ||
          tableTitle === 'All'
            ? true
            : false,
        customBodyRenderLite: (dataIndex) => {
          const v = data[dataIndex].symbol;

          return (
            <div className={v === '' ? classes.errBadge : null}>
              {v === '' ? 'Missing Value' : v}
            </div>
          );
        },
      },
    },
    {
      name: 'cusip',
      label: 'Cusip',
      options: {
        display:
          tableTitle === 'Trade' ||
          tableTitle === 'Position Movement' ||
          tableTitle === 'Cash and/or Position Movement' ||
          tableTitle === 'All'
            ? true
            : false,
      },
    },
    {
      name: 'isin',
      label: 'ISIN',
      options: {
        display:
          tableTitle === 'Trade' ||
          tableTitle === 'Position Movement' ||
          tableTitle === 'Cash and/or Position Movement' ||
          tableTitle === 'All'
            ? true
            : false,
        customBodyRenderLite: (dataIndex) => {
          const v = data[dataIndex].isin;
          return (
            <div style={{ fontFamily: 'monospace', fontSize: '0.9em' }}>
              {v || ''}
            </div>
          );
        },
      },
    },
    {
      name: 'exchangeMic',
      label: 'MIC',
      options: {
        display:
          tableTitle === 'Trade' ||
          tableTitle === 'Position Movement' ||
          tableTitle === 'Cash and/or Position Movement' ||
          tableTitle === 'All'
            ? true
            : false,
        customBodyRenderLite: (dataIndex) => {
          const v = data[dataIndex].exchangeMic;
          return (
            <div style={{ fontFamily: 'monospace', fontSize: '0.9em' }}>
              {v || ''}
            </div>
          );
        },
      },
    },
    {
      name: 'side',
      label: 'Side',
      options: {
        display: tableTitle === 'Trade' || tableTitle === 'All' ? true : false,
        customBodyRenderLite: (dataIndex) => {
          const v = data[dataIndex].side;

          return (
            <div className={v === '' ? classes.errBadge : null}>
              {v === '' ? 'Missing Value' : v}
            </div>
          );
        },
      },
    },
    {
      name: 'qty',
      label: 'Qty',
      options: {
        display:
          tableTitle === 'Trade' ||
          tableTitle === 'Position Movement' ||
          tableTitle === 'Cash and/or Position Movement' ||
          tableTitle === 'All'
            ? true
            : false,
        customBodyRenderLite: (dataIndex) => {
          const v = data[dataIndex].qty;

          return (
            <div align="right" className={v === '' ? classes.errBadge : null}>
              {v === '' ? 'Missing Value' : v}
            </div>
          );
        },
      },
    },
    {
      name: 'price',
      label: 'Price',
      options: {
        display:
          tableTitle === 'Trade' ||
          tableTitle === 'Position Movement' ||
          tableTitle === 'Cash and/or Position Movement' ||
          tableTitle === 'All'
            ? true
            : false,
        customBodyRenderLite: (dataIndex) => {
          const v = data[dataIndex].price;

          return (
            <div align="right" className={v === '' ? classes.errBadge : null}>
              {v === '' ? 'Missing Value' : v}
            </div>
          );
        },
      },
    },
    {
      name: 'contraAccountNo',
      label: 'Contra Account No',
      options: {
        customBodyRenderLite: (dataIndex) => {
          const v = data[dataIndex].contraAccountNo;

          return (
            <div className={v === '' ? classes.errBadge : null}>
              {v === '' ? 'Missing Value' : v}
            </div>
          );
        },
      },
    },
    {
      name: 'settleDate',
      label: 'Settle Date',
      options: {
        customBodyRenderLite: (dataIndex) => {
          const v = data[dataIndex].settleDate
            ? moment(data[dataIndex].settleDate).format('YYYY-MM-DD')
            : '';
          return <div>{v}</div>;
        },
      },
    },
    {
      name: 'holdDate',
      label: 'Hold Date',
      options: {
        display:
          tableTitle === 'Position Movement' ||
          tableTitle === 'Cash and/or Position Movement' ||
          entrytype === 'ACATC',
        customBodyRenderLite: (dataIndex) => {
          const v = data[dataIndex].holdDate
            ? moment(data[dataIndex].holdDate).format('YYYY-MM-DD')
            : '';
          return <div>{v}</div>;
        },
      },
    },
    {
      name: 'grossAmt',
      label: 'Gross Amt',
      options: {
        display: tableTitle === 'Trade' || tableTitle === 'All' ? true : false,
        options: {
          customBodyRenderLite: (dataIndex) => {
            const v = data[dataIndex].grossAmt;

            return <div align="right">{v}</div>;
          },
        },
      },
    },
    {
      name: 'netAmt',
      label: 'Net Amt',
      options: {
        display:
          tableTitle === 'Trade' ||
          tableTitle === 'Cash Movement' ||
          tableTitle === 'Cash and/or Position Movement' ||
          tableTitle === 'All'
            ? true
            : false,
        customBodyRenderLite: (dataIndex) => {
          const v = data[dataIndex].netAmt;

          return (
            <div align="right" className={v === '' ? classes.errBadge : null}>
              {v === '' ? 'Missing Value' : v}
            </div>
          );
        },
      },
    },
    {
      name: 'fees',
      label: 'Fees',
      options: {
        display: tableTitle === 'Trade' || tableTitle === 'All' ? true : false,
        options: {
          customBodyRenderLite: (dataIndex) => {
            const v = data[dataIndex].fees;

            return <div align="right">{v}</div>;
          },
        },
      },
    },
    {
      name: 'description',
      label: 'Description',
    },
    {
      name: 'executionId',
      label: 'Execution ID',
      options: {
        display:
          tableTitle === 'Trade' ||
          tableTitle === 'Cash Movement' ||
          tableTitle === 'All'
            ? true
            : false,
      },
    },
    {
      name: 'externalId',
      label: 'External ID',
      options: {
        display:
          tableTitle === 'Trade' ||
          tableTitle === 'Cash Movement' ||
          tableTitle === 'All'
            ? true
            : false,
      },
    },
    {
      name: 'executingVenue',
      label: 'Executing Venue',
      options: {
        display: tableTitle === 'Trade' || tableTitle === 'All' ? true : false,
      },
    },
    {
      name: 'leavesQty',
      label: 'Leaves Qty',
      options: {
        display: tableTitle === 'Trade' || tableTitle === 'All' ? true : false,
      },
    },
    {
      name: 'orderId',
      label: 'Order ID',
      options: {
        display: tableTitle === 'Trade' || tableTitle === 'All' ? true : false,
      },
    },
    {
      name: 'vendor',
      label: 'Vendor',
      options: {
        display:
          tableTitle === 'Cash Movement' || tableTitle === 'All' ? true : false,
      },
    },
    {
      name: 'contraAccountDesignator',
      label: 'Contra Account Designator',
      options: {
        display: true,
        customBodyRenderLite: (dataIndex) => {
          const v = data[dataIndex].contraAccountDesignator;
          if (v === '2') return <div>Long (2)</div>;
          if (v === '3') return <div>Short (3)</div>;
          return <div>{v || ''}</div>;
        },
      },
    },
    {
      name: 'contraCorrespondent',
      label: 'Contra Correspondent',
      options: {
        display:
          tableTitle === 'Trade' ||
          tableTitle === 'Cash Movement' ||
          tableTitle === 'Position Movement' ||
          tableTitle === 'Cash and/or Position Movement' ||
          tableTitle === 'All'
            ? true
            : false,
      },
    },
    {
      name: 'refId',
      label: 'Ref ID',
    },
    {
      name: 'contraSymbol',
      label: 'Currency',
    },
    {
      name: 'swapRate',
      label: 'Swap Rate',
      options: {
        customBodyRenderLite: (dataIndex) => {
          const c = data[dataIndex].contraSymbol;
          const v = data[dataIndex].swapRate;

          return (
            <div
              align="right"
              className={
                c !== '' && c !== 'USD' && v === '' ? classes.errBadge : null
              }
            >
              {c !== '' && c !== 'USD' && v === '' ? 'Missing Value' : v}
            </div>
          );
        },
      },
    },
    {
      name: 'swapRateAt',
      label: 'Swap Rate At',
    },
    {
      name: 'localNetAmt',
      label: 'Local Net Amt',
      options: {
        display:
          tableTitle === 'Cash Movement' ||
          tableTitle === 'Cash and/or Position Movement' ||
          tableTitle === 'All'
            ? true
            : false,
        customBodyRenderLite: (dataIndex) => {
          const c = data[dataIndex].contraSymbol;
          const v = data[dataIndex].localNetAmt;

          return (
            <div
              align="right"
              className={
                c !== '' && c !== 'USD' && v === '' ? classes.errBadge : null
              }
            >
              {c !== '' && c !== 'USD' && v === '' ? 'Missing Value' : v}
            </div>
          );
        },
      },
    },
    {
      name: 'swapFeeBpsAlpa',
      label: 'Swap Fee Bps Alpa',
    },
    {
      name: 'swapFeeBpsCorr',
      label: 'Swap Fee Bps Corr',
    },
    {
      name: 'metadata',
      label: 'Metadata',
    },
    {
      name: 'localFees',
      label: 'Local Fees',
      options: {
        display: tableTitle === 'Trade' || tableTitle === 'All' ? true : false,
        options: {
          customBodyRenderLite: (dataIndex) => {
            const v = data[dataIndex].localFees;
            return <div align="right">{v}</div>;
          },
        },
      },
    },
  ];

  const options = {
    filterType: 'select',
    download: true,
    filter: true,
    search: false,
    print: false,
    sort: true,
    viewColumns: true,
    selectableRows: 'none',
    onDownload: (buildHead, buildBody, columns, values) => {
      downloadExcelData(fileName, columns, values);
      return false;
    },
  };

  return (
    <div className={classes.root}>
      <Box component="div">
        <MuiThemeProvider theme={tableTheme()}>
          <MUIDataTable
            style={{ background: 'red' }}
            title={'Batch Transaction: ' + tableTitle}
            data={data}
            columns={columns}
            options={options}
          />
        </MuiThemeProvider>
      </Box>
      {isEdit && (
        <TransactionUploadEditModal
          onClose={handleClose}
          open={isEdit}
          value={editData}
        ></TransactionUploadEditModal>
      )}
    </div>
  );
}
